export default function Welcome({ setCurrentPage }) {
  return (
    <div className='fixedMobileSize'>
      {/* <img src={'https://res.cloudinary.com/cbc2021/image/upload/q_auto:low/welcomePage_rk477c.png'} className={'welcome'} alt='welcomePage' /> */}
      <img src={'https://res.cloudinary.com/da0jtwj5x/image/upload/q_auto:low/v1774684936/aurudu2026/1-page_hugude.jpg'} className={'welcome'} alt='welcomePage' />

      <a
        onClick={() => {
          setCurrentPage(2);
        }}
      >
        <img src={'https://res.cloudinary.com/experbot-com/image/upload/w_300/Aurudu/idiriyata_yanna_wp3uza.png'} className={'welcomeButton'} alt='button' />
      </a>
    </div>
  );
}
